import { useSelector } from 'react-redux';

import { selectCustomFacets } from '../selectors/customFacets';
import { selectFacets } from '../selectors/facets';
import { extractRefinedFacetsFromFacets } from '../utils/refinedFacets';

export interface BooleanRefinedFacet {
  type: 'boolean';
  facetName: string;
  value: 'true' | 'false';
}

export interface FacetRefinedFacet {
  type: 'checkbox' | 'color' | 'custom' | 'radio';
  facetName: string;
  value: string;
}

export interface RangeRefinedFacet {
  type: 'range';
  facetName: string;
  value: { min?: number; max?: number };
}

export type RefinedFacet =
  | BooleanRefinedFacet
  | FacetRefinedFacet
  | RangeRefinedFacet;

// NOTE Refined facets are based on {facets} and {customFacets}
export const useRefinedFacets = (): RefinedFacet[] => {
  const facets = useSelector(selectFacets) || {};
  const customFacets = useSelector(selectCustomFacets) || {};

  return extractRefinedFacetsFromFacets({ ...facets, ...customFacets });
};
